import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  dietPlanList: []
};

const dietPlanReducerSlice=createSlice({
  name:"dietPlan",
  initialState,
  reducers:{
    updateDietPlans(state,action){
      return{
        ...state,
        dietPlanList: [...action.payload]
      } 
    },
    updateDietPlan(state,action){
      return{
        ...state,
        dietPlanList: state.dietPlanList.map((dietPlan) => {
          if (dietPlan._id === action.payload.id) {
            return action.data;
          }
          return dietPlan;
        })
      }
    }
  }
})


export const dietPlanReducerAction = dietPlanReducerSlice.actions
export const dietPlanReducers = dietPlanReducerSlice.reducer
